import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import { useTranslation } from "react-i18next";
import { axiosGateway } from "../../../../api/axios";
import "./InviteFriendsSection.css";
import inviteMailGmailIcon from "../../../../assets/icons/svg/invite-mail-gmail.svg";
import inviteSendWhiteIcon from "../../../../assets/icons/svg/invite-send-white.svg";

const SERVICE_ID = "service_j6fk5ml";
const TEMPLATE_ID = "template_uplzaid";
const PUBLIC_KEY = "KeLD0RHINxsuFLiU9";

const InviteFriendsSection = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(""); // "success" or "error"
  const [isSending, setIsSending] = useState(false);

  const handleEmailChange = (e) => setEmail(e.target.value);

  const handleSendInvite = async () => {
    const trimmedEmail = email.trim();
    
    // ✅ Validation basique de l'email
    if (!trimmedEmail) {
      setStatus("empty");
      setTimeout(() => setStatus(""), 3000);
      return;
    }

    // ✅ Validation du format email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(trimmedEmail)) {
      setStatus("invalid");
      setTimeout(() => setStatus(""), 3000);
      return;
    }

    setIsSending(true);
    try {
      const response = await axiosGateway.post("/referrals/invitations", {
        inviteeEmail: trimmedEmail,
      });
      const token = response.data?.data?.token;
      if (!token) throw new Error("Referral token missing");

      const invitationLink = `${window.location.origin}/SignupPatient?ref=${encodeURIComponent(token)}`;
      await emailjs.send(SERVICE_ID, TEMPLATE_ID, {
        email: trimmedEmail,
        invitation_link: invitationLink,
        referral_link: invitationLink,
      }, PUBLIC_KEY);
      setStatus("success");
      setEmail("");
    } catch (error) {
      console.error("Invitation error:", error);
      setStatus("error");
    } finally {
      setIsSending(false);
      setTimeout(() => setStatus(""), 3000);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !isSending) {
      handleSendInvite();
    }
  };

  // ✅ Fonction pour obtenir le message de statut
  const getStatusMessage = () => {
    switch (status) {
      case "success":
        return `✅ ${t('inviteFriends.successMessage')}`;
      case "error":
        return `❌ ${t('inviteFriends.errorMessage')}`;
      case "empty":
        return `⚠️ ${t('inviteFriends.emptyMessage')}`;
      case "invalid":
        return `⚠️ ${t('inviteFriends.invalidMessage')}`;
      default:
        return "";
    }
  };

  return (
    <div className="invite-friends-container">
      <div className="invite-header">
        <img src={inviteMailGmailIcon} className="mail-icon" alt="" aria-hidden="true" />
        <h3 className="invite-title">{t('inviteFriends.title')}</h3>
      </div>

      <p className="invite-description">
        {t('inviteFriends.description')}
      </p>

      <div className="email-section">
        <h4 className="email-title">{t('inviteFriends.emailTitle')}</h4>

        <div className="email-input-container">
          <input
            type="email"
            className="email-input"
            placeholder={t('inviteFriends.emailPlaceholder')}
            value={email}
            onChange={handleEmailChange}
            onKeyPress={handleKeyPress}
            disabled={isSending}
            aria-label={t('inviteFriends.emailAriaLabel')}
          />

          <button 
            className="send-button" 
            onClick={handleSendInvite}
            disabled={isSending}
            aria-label={t('inviteFriends.sendButtonAriaLabel')}
            title={t('inviteFriends.sendButtonTitle')}
          >
            {isSending ? (
              <svg 
                className="send-icon spinner" 
                width="25" 
                height="25" 
                viewBox="0 0 24 24" 
                fill="none"
              >
                <circle 
                  cx="12" 
                  cy="12" 
                  r="10" 
                  stroke="white" 
                  strokeWidth="2" 
                  strokeDasharray="31.4 31.4" 
                  strokeLinecap="round"
                />
              </svg>
            ) : (
              <img src={inviteSendWhiteIcon} className="send-icon" alt="" aria-hidden="true" />
            )}
          </button>
        </div>
      </div>

      {/* Centered message overlay */}
      {status && (
        <div 
          className={`message-overlay ${status}`}
          role="alert"
          aria-live="polite"
        >
          {getStatusMessage()}
        </div>
      )}
    </div>
  );
};

export default InviteFriendsSection;